import { HomePage, TasksPage, ProfilePage, TemplatePage, GenerateDocPage,
         TemplatesPage, GenerateDocQuestionsPage, GenerateDocEditPage,
         GenerateDocPrintPage, DocumentsPage, } from './pages';
import { withNavigationWatcher } from './contexts/navigation';

const routes = [
    {
        path: '/tasks',
        element: TasksPage
    },
    {
        path: '/profile',
        element: ProfilePage
    },
    {
        path: '/home',
        element: HomePage
    },
    {
        path: '/templates',
        element: TemplatesPage
    },
    {
        path: '/documents',
        element: DocumentsPage
    },
    {
        path: '/template',
        element: TemplatePage
    },
    {
        path: '/template/:template_id',
        element: TemplatePage
    },
    {
        path: '/generate/:template_id',
        element: GenerateDocPage
    },
    {
        path: '/generate/questions/:template_id',
        element: GenerateDocQuestionsPage
    },
    {
        path: '/generate/edit/:document_id',
        element: GenerateDocEditPage
    },
    {
        path: '/generate/print/:document_id',
        element: GenerateDocPrintPage
    },


];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
